import { useEffect, useRef } from 'react';

export const useInfiniteTrigger = <T extends Element = HTMLDivElement>({
  fetchNextPage,
  hasNextPage,
  isFetching,
  options,
}: {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetching: boolean;
  options?: IntersectionObserverInit;
}) => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      if (isFetching) return;
      if (!hasNextPage) return;

      fetchNextPage();
    }, options);

    observer.observe(el);
    return () => observer.disconnect();
  }, [fetchNextPage, isFetching, hasNextPage, options]);

  return ref;
};
